import { formatUSDT } from "@/lib/mockData";

/** 托管领取收益弹窗：TSK 未发行时置灰展示 */
export const CUSTODY_TSK_TOKEN_LAUNCHED = false;

export function formatCustodyTskUsdValue(usd: number): string {
  return `≈$${formatUSDT(usd)}`;
}

export const custodyTskLockedCardStyle = {
  background: "rgba(255,255,255,0.02)",
  border: "1px solid rgba(255,255,255,0.08)",
  opacity: 0.6,
} as const;
